let Backbone = window.Backbone;
let _ = window._;
let $ = jQuery;

import itemView from './Item.view';


export default Backbone.View.extend({
  events: {
    'click .js-userContent__loadMore': 'loadMore',
    'keyup .js-userContent__search': 'search',
    'search .js-userContent__search': 'search',
  },

  el: $('.js-userContent'),
  emptyOnSync: true,

  initialize: function(options) {
    this.filtersColection = options.filters
    this.grid = this.$el.find('.js-userContent__grid');

    this.initMasonry();

    if(this.filtersColection) {
      this.filtersColection.on('all', this.filtersUpdate, this);
      this.filtersUpdate();
    } else {
      this.collection.fetch();
    }

    this.collection.on('sync', this.onSync, this);
  },

  initMasonry: function() {
    this.masonry = this.grid.masonry({
      itemSelector: '.userContent__item',
      percentPosition: true
    });
  },

  onSync: function() {
    this.$el.removeClass('is-loading is-loading-alt is-loading-filters');

    if(this.emptyOnSync) {
      this.grid.masonry('remove', $('.userContent__item'));
    }

    this.collection.each(this.render, this);

    this.emptyOnSync = true;
    this.maybeShowPagination();

    if(this.collection.length === 0) {
      this.showNotFound();
    }
  },

  filtersUpdate: function(action) {
    this.startLoading(true);

    this.collection.updateFilters(this.filtersColection.toJSON());

    this.collection.searchQuery($('.js-userContent__search', this.el).val());

    if(action === 'update') {
      this.collection.getPage(1);
    } else {
      this.collection.fetch();
    }
  },

  maybeShowPagination: function() {
    if(this.collection.hasNextPage()) {
      this.$el.addClass('has-next-page');
    } else {
      this.$el.removeClass('has-next-page');
    }
  },

  render: function(item) {
    let newItem = new itemView({
      model: item
    }).$el;

    this.grid
      .masonry()
      .append(newItem)
      .masonry('appended', newItem)
      .masonry();

    this.grid.imagesLoaded().progress(() => {
      this.grid.masonry('layout');
    });

    return this;
  },


  showNotFound: function() {
    let notFound = _.template($('#userContent-itemsNotFound-tpl').html());

    this.grid.empty()
      .masonry()
      .append(notFound)
      .masonry('appended', notFound)
      .masonry();
  },

  search: function(e) {
    e.preventDefault();
    this.collection.searchQuery(e.currentTarget.value);
    this.startLoading(true);

    this.collection.getPage(1);
  },

  loadMore: function(e) {
    e.preventDefault();
    this.emptyOnSync = false;
    this.startLoading();
    this.collection.loadMore();
  },

  startLoading: function(isFilterLoading = false) {
    let loadingClass = 'is-loading';

    if(Math.random() > 0.5) {
      loadingClass += ' is-loading-alt';
    }

    if(isFilterLoading) {
      loadingClass += ' is-loading-filters';
    }

    this.$el.addClass(loadingClass);
  },
});


// WEBPACK FOOTER //
// ./assets/src/javascripts/userContent/grid/Items.view.js